import KyeTable2 from './table'
export default KyeTable2



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/index.js